<template>
    <div class="xywcqkIndex">
        <Header :title="title" type="0" route="/homeIndex"></Header>
        <div class="content">
            <el-table :data="tableData" border style="width: 100%" :row-class-name="tableRowClassName1">
                <el-table-column type="expand" min-width="10%">
                    <template slot-scope="props">
                        <el-table class="child-table" v-if="props.row.xfyqid == 'cxcyxfyq'" :data="props.row.kclist" style="width: 100%" :row-class-name="tableRowClassName">
                            <el-table-column prop="hdlx" label="活动类型" min-width="15%"> </el-table-column>
                            <el-table-column prop="hdmc" label="活动名称" min-width="35%"> </el-table-column>
                            <el-table-column prop="xnxq01id" label="学期" min-width="30%"> </el-table-column>
                            <el-table-column prop="cxxf" label="学分" min-width="15%"> </el-table-column>
                        </el-table>

                        <el-table class="child-table" v-if="props.row.xfyqid == 'bxhjxfyq' || props.row.xfyqmc === '必修环节要求'" :data="props.row.kclist" style="width: 100%" :row-class-name="tableRowClassName1">
                            <el-table-column prop="kch" label="课程编号" min-width="15%"> </el-table-column>
                            <el-table-column prop="kcmc" label="课程名称" min-width="25%"> </el-table-column>
                            <el-table-column prop="xf" label="学分" min-width="15%"> </el-table-column>
                            <el-table-column prop="kcxz" label="课程性质" min-width="30%"> </el-table-column>
                            <el-table-column prop="sfjhkc" label="是否计划内" min-width="15%">
                                <template slot-scope="scope">
                                    {{ scope.row.sfjhkc == '1' ? '是' : '否' }}
                                </template>
                            </el-table-column>
                            <el-table-column prop="cjxs" label="总成绩" min-width="15%"></el-table-column>
                        </el-table>

                        <el-table class="child-table" v-if="props.row.isShow" :data="props.row.kclist" style="width: 100%" :row-class-name="tableRowClassName2">
                            <el-table-column prop="kch" label="课程编号" min-width="15%"> </el-table-column>
                            <el-table-column prop="kcmc" label="课程名称" min-width="35%"> </el-table-column>
                            <el-table-column prop="cjhdxq" label="学期" min-width="30%"> </el-table-column>
                            <el-table-column prop="xf" label="学分" min-width="15%"> </el-table-column>
                            <el-table-column prop="cjxs" label="总成绩" min-width="15%"></el-table-column>
                        </el-table>
                    </template>
                </el-table-column>
                <el-table-column prop="xfyqmc" label="课程体系" min-width="25%"> </el-table-column>
                <el-table-column prop="xfyq" label="要求学分" min-width="15%"> </el-table-column>
                <el-table-column prop="hdxf" label="已修学分" min-width="15%"> </el-table-column>
                <el-table-column prop="hxxf" label="还需学分" min-width="15%">
                    <template slot-scope="scope">
                        {{ scope.row.hxxf == '' ? '0' : scope.row.hxxf }}
                    </template>
                </el-table-column>
                <el-table-column prop="bljl" label="是否通过" min-width="20%"> </el-table-column>
                <!-- <el-table-column prop="cjsj" label="录入时间"> </el-table-column> -->
            </el-table>
        </div>
    </div>
</template>

<script>
import { Api } from '@/utils/axios';

export default {
    data() {
        return {
            tableData: [],
            title: '',
            txxtList: [],
            isShow: false
        };
    },
    created() {
        this.title = this.$route.query.title;
        this.getList();
    },
    methods: {
        tableRowClassName({ row, rowIndex }) {
            if (row.ysclass == 'lshgclass') {
                return 'green-row';
            } else if (row.ysclass == 'hshgclass') {
                return 'red-row';
            }
            return '';
        },
        tableRowClassName2({ row, rowIndex }) {
            if (row.ysclass == 'lshgclass') {
                return 'green-row';
            } else if (row.ysclass == 'hshgclass') {
                return 'red-row';
            }
            return '';
        },
        tableRowClassName1({ row, rowIndex }) {
            // if (row.wcqk === 'jg' || row.Cjxs == '免修') {
            //     return 'green-row';
            // } else if (row.wcqk === 'bjg') {
            //     return 'red-row';
            // } else if (row.wcqk === 'blue') {
            //     return 'blue-row';
            // }
            // return 'gray-row';

            if (row.wcqk === 'jg' || row.Cjxs == '免修') {
                return 'gray-row';
            } else if (row.wcqk === 'bjg') {
                return 'gray-row';
            } else if (row.wcqk === 'blue') {
                return 'gray-row';
            } else if (row.wcqk === '') {
                return 'gray-row';
            }
            return 'gray-row';
        },
        async getList() {
            if (this.title === '学业完成情况') {
                const res = await Api.zxxywcqk();
                // res.data.txxfyqlist.forEach((item) => {
                //     if (item.kclist.length > 0) {
                //         this.isShow = true;
                //     }
                //     this.tableData.push(item);
                // });
                console.log('res-data: ', res);
                let targetArr = [];

                targetArr.push(res.data.cxcyxfyq);
                targetArr.push(res.data.bxhjxfyq);
                const txxfyqlist = res.data.txxfyqlist.map((item) => {
                    item.isShow = item.kclist.length > 0;
                    return item;
                });
                targetArr = [...targetArr, ...txxfyqlist];
                targetArr.push({
                    xfyqmc: '总计',
                    xfyq: res.data.zxfyq,
                    hdxf: res.data.zhdxf,
                    hxxf: res.data.zhxxf,
                    bljl: ''
                });
                this.tableData = targetArr;
            } else {
                const res = await Api.fxxywcqk();
                this.tableData = res.data.txxfyqlist;
                this.tableData.push({
                    xfyqmc: '总计',
                    xfyq: res.data.zxfyq == '' ? '0' : res.data.zxfyq,
                    hdxf: res.data.zhdxf == '' ? '0' : res.data.zhdxf,
                    hxxf: res.data.zhxxf == '' ? '0' : res.data.zhxxf,
                    bljl: ''
                });
            }
        }
    }
};
</script>

<style lang="less" scoped>
.xywcqkIndex {
    .content {
        padding: 0 20px;
    }
}
</style>
<style lang="less">
.xywcqkIndex {
    .el-table td {
        border-bottom: 1px solid #ebeef5 !important;
    }
}
.el-table .green-row {
    color: rgb(0, 100, 0);
    background: #f0f9eb;
}
.el-table .red-row {
    color: red;
    background-color: rgba(255, 128, 128, 0.4);
}
.el-table .blue-row {
    color: #0000ff;
    background-color: rgba(0, 255, 255, 0.4);
}
.el-table .gray-row,
.child-table th {
    background-color: rgba(240, 240, 240, 0.4);
}
.child-table {
    border: 1px solid #000;
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/student/xywcqk/index.vue